import { render, staticRenderFns } from "./AffiliateInvoiceInfo.vue?vue&type=template&id=6f8ed810&scoped=true&"
import script from "./AffiliateInvoiceInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateInvoiceInfo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateInvoiceInfo.vue?vue&type=style&index=0&id=6f8ed810&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ed810",
  null
  
)

export default component.exports